import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class AutomobileModel extends AbstractModel {
  @autoserialize
  name: string;
}
